module.exports = __webpack_public_path__ + "static/img/6106_phase_function_Paper_PointsHejduk_Prediction.212e6ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6106_phase_function_Paper_PointsHejduk_Prediction.png
// module id = KXxY
// module chunks = 0